import React, { useContext } from 'react'
import "../Layout/Layout.css"
import AccountSettings from '../../component/AccountSettings/AccountSettings'
import MyContext from '../../Context/AppContext'

const SettingsPage = () => {
    const { openDrawer, checkAuthStatus } = useContext(MyContext);
    const isLoggedIn = checkAuthStatus();


    return (
        <>
            {
                isLoggedIn && <div className='maindiv_chatpage' >
                    <div className={openDrawer ? 'rightside_chatpage drawerOpen' : 'rightside_chatpage drawerClose'}>
                        <AccountSettings openDrawer={openDrawer} />
                    </div>
                </div>
            }
        </>
    )
}

export default SettingsPage